var React = require('react');

function ZoomInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("path",{"className":"st0","d":"M15.1,2.9c6.7,0,12.2,5.5,12.2,12.2c0,6.7-5.5,12.2-12.2,12.2S2.9,21.9,2.9,15.1C2.9,8.4,8.4,2.9,15.1,2.9z\n\t M33.6,29.6l-6-6c4.4-6.4,3.1-15.1-2.9-20.1c-6-5-14.8-4.5-20.3,1c-5.5,5.5-5.9,14.3-1,20.3c4.9,6,13.6,7.3,20.1,2.9l6.1,6\n\tc1.1,1.1,2.9,1.1,4.1,0C34.8,32.5,34.8,30.7,33.6,29.6z","key":1})]);
}

ZoomInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 34.5 34.5","style":{"enableBackground":"new 0 0 34.5 34.5"},"xmlSpace":"preserve"};

module.exports = ZoomInline;

ZoomInline.default = ZoomInline;
